<template>
    <v-row>
        <v-col cols="12" md="auto">
            <v-card outlined rounded="lg">
                <v-img :src="value?.thumb?.src" width="233" :aspect-ratio="282 / 438" class="grey-f8">
                    <template #placeholder>
                        <v-overlay absolute color="transparent">
                            <v-icon x-large color="grey-b3">mdi-image-broken-variant</v-icon>
                        </v-overlay>
                    </template>
                </v-img>
            </v-card>
        </v-col>
        <v-col>
            <v-chip-group class="mb-8">
                <v-chip outlined label color="primary">
                    <span class="font-size-14"> {{ value._employees.length.format() }}명 참여 </span>
                </v-chip>
                <v-chip outlined label color="secondary">
                    <span class="font-size-14"> {{ value._employers.length.format() }}개 기업 참여 </span>
                </v-chip>
            </v-chip-group>
            <a :href="`/programs/${value._id}`">
                <h5 class="tit--sm d-inline font-weight-bold text-truncate mb-8">
                    {{ value.subject }}
                </h5>
            </a>
            <p class="page-text--lg font-weight-regular text-truncate primary--text mb-24">
                {{ value.host.name }}
            </p>
            <p class="page-text mb-24">
                {{ value.summary }}
            </p>

            <v-divider class="primary border-2" />
            <v-row justify="space-between" class="mt-0 mx-0 mb-24">
                <v-col cols="12" class="grey-f7">
                    <v-row>
                        <v-col cols="auto" class="font-weight-medium text-center"> 프로그램 진행기간 </v-col>
                        <v-col cols="auto" class="font-weight-regular grey--text"> {{ value.date.programDisplay.text }} </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" xl="auto">
                    <v-row>
                        <v-col cols="auto" class="font-weight-medium text-center"> 기업회원 접수기간 </v-col>
                        <v-col cols="auto" class="font-weight-regular grey--text"> {{ value.date.employerSubmit.text }} </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" xl="auto">
                    <v-row>
                        <v-col cols="auto" class="font-weight-medium text-center"> 개인회원 접수기간 </v-col>
                        <v-col cols="auto" class="font-weight-regular grey--text"> {{ value.date.employeeSubmit.text }} </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" xl="auto">
                    <v-row>
                        <v-col cols="auto" class="font-weight-medium text-center"> 매칭기간 </v-col>
                        <v-col cols="auto" class="font-weight-regular grey--text"> {{ value.date.matchingSubmit.text }} </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" xl="auto">
                    <v-row>
                        <v-col cols="auto" class="font-weight-medium text-center"> 면접기간 </v-col>
                        <v-col cols="auto" class="font-weight-regular grey--text"> {{ value.date.interviewSpans.text }} </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <slot name="actions" />
        </v-col>
    </v-row>
</template>

<script>
import { initExpoProgram } from "@/assets/variables";
export default {
    props: {
        value: { type: Object, default: initExpoProgram },
    },
};
</script>

<style>
</style>